import {useTheme} from '@mui/material/styles';
import {Stack, Box, Button, Container, Typography, useMediaQuery} from '@mui/material';
import {useNavigate} from 'react-router-dom';

const buttonStyles = {
  mt: {
    xs: 2,
    sm: 4,
  },
  color: 'white',
  background: theme => theme.palette.primary.main,
  borderRadius: 6,
  fontWeight: 600,
  width: {
    xs: '100%',
    sm: '300px',
  },
};

/**
 * React functional component representing the Null Error Page.
 * @component
 * @returns {JSX.Element} The rendered NullErrorPage component.
 */
export const NullErrorPage = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="lg"
      sx={{
        px: 4,
      }}
    >
      <Stack spacing={2} alignItems="center" justifyContent="center" sx={{height: '100vh'}}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            textAlign: 'center',
            ...(isSmallScreen ? {fontSize: 15} : {}),
            mb: 3,
          }}
        >
          Face Scan Unsuccessful
        </Typography>
        <Typography variant="h6" sx={{marginTop: 4, maxWidth: '800px', width: '80%'}} textAlign="center">
          The face scan was not successful because blood flow could not be measured reliably.
        </Typography>
        <Typography variant="h6" sx={{marginTop: 4, maxWidth: '800px', width: '80%'}} textAlign="center">
          Please make sure the light in the room is evenly distributed across your face, and try to stay still.
        </Typography>
        <Box
          sx={{
            py: 3,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
            justifyContent: 'center',
            width: 1,
            gap: {
              xs: 0,
              sm: 2,
            },
          }}
        >
          <Button
            onClick={() => {
              navigate('/pre-face-scan');
            }}
            variant="contained"
            disableElevation
            size="large"
            sx={buttonStyles}
          >
            Try again
          </Button>
          <Button
            onClick={() => {
              navigate('/symptom-checker');
            }}
            variant="contained"
            disableElevation
            size="large"
            sx={buttonStyles}
          >
            Start a new assessment
          </Button>
        </Box>
      </Stack>
    </Container>
  );
};
